/**
 * Enumerator used to refer to a box side
 * @public
 */ var BoxSide = /*#__PURE__*/ function(BoxSide) {
    /** Left side (-x) */ BoxSide[BoxSide["LEFT"] = 0] = "LEFT";
    /** Right side (+x) */ BoxSide[BoxSide["RIGHT"] = 1] = "RIGHT";
    /** Bottom side (-y) */ BoxSide[BoxSide["BOTTOM"] = 2] = "BOTTOM";
    /** Top side (+y) */ BoxSide[BoxSide["TOP"] = 3] = "TOP";
    /** Front side (+z) */ BoxSide[BoxSide["FRONT"] = 4] = "FRONT";
    /** Back side (-z) */ BoxSide[BoxSide["BACK"] = 5] = "BACK";
    return BoxSide;
}({});
/**
 * The intersection test result of two object A and B
 * @public
 */ var ClipState = /*#__PURE__*/ function(ClipState) {
    /** A does not intersect with B */ ClipState[ClipState["NOT_CLIPPED"] = 0] = "NOT_CLIPPED";
    /** A is inside B */ ClipState[ClipState["A_INSIDE_B"] = 1] = "A_INSIDE_B";
    /** B is inside A */ ClipState[ClipState["B_INSIDE_A"] = 2] = "B_INSIDE_A";
    /** A and B partially overlap */ ClipState[ClipState["CLIPPED"] = 3] = "CLIPPED";
    return ClipState;
}({});
/**
 * Enumerator used to refer to the cube face
 * @public
 */ var CubeFace = /*#__PURE__*/ function(CubeFace) {
    /** Positive X Axis */ CubeFace[CubeFace["PX"] = 0] = "PX";
    /** Negative X Axis */ CubeFace[CubeFace["NX"] = 1] = "NX";
    /** Positive Y Axis */ CubeFace[CubeFace["PY"] = 2] = "PY";
    /** Negative Y Axis */ CubeFace[CubeFace["NY"] = 3] = "NY";
    /** Positive Z Axis */ CubeFace[CubeFace["PZ"] = 4] = "PZ";
    /** Negative Z Axis */ CubeFace[CubeFace["NZ"] = 5] = "NZ";
    return CubeFace;
}({});

export { BoxSide, ClipState, CubeFace };
//# sourceMappingURL=types.js.map
